
import { Page, PageContent, GlobalStyles } from "./styles";
import { createRef, useCallback, useEffect, useState } from "react";
import WhatsApp from "../../Whatsapp";
import { connect, useDispatch } from "react-redux";
import { setCurrentPage } from "../../../store/actions/page";
import constants from "../../../constants";
import { useWindowSize } from "../../../hooks/useWindowSize";
import ModalSelectChat from "../components/ModalSelectChat";
import { useLayout } from "../../../providers/LayoutProvider";
import MobileHeader from './components/MobileHeader'
import GroupMobileMenu from '../components/GroupMobileMenu'
import PoweredByKlouser from "../components/PoweredByKlouser";



interface ComponentProps {
  user,
  children,
  useLocation,
  showMenu,
  post,
  postStates,
  category
}

const Component = ({ children, useLocation, showMenu = true, post, user, postStates, category }: ComponentProps) => {
  const location = useLocation();
  const { layout } = useLayout();
  const dispatch = useDispatch();
  const footerRef = createRef<HTMLElement>();
  const headerRef = createRef<HTMLElement>();
  const { isMobile } = useWindowSize()
  const [minHeight, setMinHeight] = useState(56);
  const [currentPageLocally, setCurrentPageLocally] = useState<any>();

  const isOwnGroup = useCallback(() => {
    const expertId = post?.group?.expert?.id
    return expertId === user?.expert?.id;
  }, [post, user]);

  useEffect(() => {
    const page =
      location &&
      constants.pages.filter((page) => {
        return location.pathname.match(page.regex);
      });
    setCurrentPageLocally(page[0]);
    dispatch(setCurrentPage(page[0]));
  }, [location]);

  useEffect(() => {
    if (!!headerRef.current && !!footerRef.current) {
      setMinHeight(
        headerRef.current.scrollHeight + footerRef.current.scrollHeight
      );
    }
  }, [headerRef, footerRef]);

  return (
    <>
      <GlobalStyles />

      <PoweredByKlouser />

      {layout.header.beforeHeader}

      <MobileHeader />

      <Page
        showMenu={showMenu}
        minHeight={minHeight}
        currentPage={currentPageLocally}
      >
        <PageContent>{children}</PageContent>
      </Page>

      {isMobile && showMenu && (
        <GroupMobileMenu useLocation={useLocation} />
      )}

      {layout?.show_whatsapp && <WhatsApp floating options={{ marginBottom: post?.is_free && isMobile ? 0 : 50 }} />}

      <ModalSelectChat />
    </>
  );
};

const state = ({ postStore, categoryStore, userStore }) => {
  const { data: user, states: userStates } = userStore.information;
  const { data: post, states: postStates } = postStore.post;
  const { data: category, states: categoryStates } = categoryStore.singleCategory;

  return {
    user,
    userStates,
    post,
    postStates,
    category,
    categoryStates
  };
};

export default connect(state)(Component);
